import { NOT_AVAILABLE_PLACEHOLDER } from "@app/projects/zip-projects/maps/ZipCoverageMapConstants";

/** Gains and Impact are optional on ProviderMapResults, so an unguarded render produces a bare "%". */
export const formatPercent = (percent: number | null | undefined): string =>
  percent != null ? `${percent}%` : NOT_AVAILABLE_PLACEHOLDER;
